export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TOGGLE_SIDEBAR_DROPDOWN: "TOGGLE_SIDEBAR_DROPDOWN"
};
